import SimpleAssessmentController from './simple_assessment_controller'
import $fq                        from '../../support/fake_query'

export default class extends SimpleAssessmentController {

  static targets = [
    'hba1cDetails',
    'hba1cInput'
  ]

  connect() {}

  initialize() {}

  disconnect() {}

  // ==== Controllers

  // ==== Actions

  toggleHba1c(event) {
    const element = event.currentTarget

    if (parseInt(element.value, 10) >= 6) {
      $fq(this.hba1cDetailsTarget).show()
    } else {
      this.resetInputs(this.hba1cInputTargets)
      $fq(this.hba1cDetailsTarget).hide()
    }
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
